import { UnitTime } from "@appshared";
//Define the limit time that got when creating a new request form
export class LimitTime {
  value?: number;
  unit?: UnitTime;
  constructor(timeValue: number, timeUnit: UnitTime) {
    this.value = timeValue;
    this.unit = timeUnit;
  }
}
